<template>
    <div>
        <fieldset :disabled="formDisabled">
            <loader v-show="isLoading" />
            <form class="form form-horizontal" v-on:submit.prevent data-vv-scope="buildingForm" v-show="!isLoading">
                <div class="row">
                    <div class="col-sm-3">
                        <h4>Attachment {{buildingDto.attachmentNumber}} of {{attachmentCount}} </h4>
                    </div>
                    <div class="col-sm-4">
                        <label>Attachment ID:</label> {{buildingDto.dbNumber}}
                    </div>
                </div>
                <div v-if="qaqcEnabled" class="row" style="margin-bottom: 20px;">
                    <label class="col-md-3">Attachment Selection:</label>
                    <div class="col-md-7">
                        <select class="form-control" v-model="qaqcSelection.attachmentSelection">
                            <option disabled :value="-1">Attachment Selection</option>
                            <option :value="0">Add As New Production Attachment</option>
                            <option v-for="attachment in productionAttachmentList" :value="attachment.historicBuildingFormId" :key="attachment.historicBuildingFormId">
                                Update Production Attachment: {{attachment.dbNumber}}
                            </option>
                        </select>
                    </div>
                </div>
                <!-- <div v-if="this.isSegment" class="form-group">
                    <label class="col-md-2 control-label text-label">Building Selection</label>
                    <div class="col-md-6">
                        <select class="form-control" v-model="buildingDto.memberCulturalResourceId">
                            <option :value="null">Building Selection</option>
                            <option v-for="member in selectableSegmentList" :value="member.culturalResourceId"> {{member.smithsonianNumber}}</option>
                        </select>
                    </div>
                    <div class="col-md-2" v-if="!formDisabled && !qaqcEnabled">
                        <router-link :to="{ path: '/SiteNumberRequest', query: { projectId: projectId }}" tag="button" class="btn btn-primary btn-block">Segment Request</router-link>
                    </div>
                </div> -->
                <div v-if="this.isSegment" class="form-group">
                    <label class="col-sm-2 control-label text-label">Building Contribution</label>
                    <div class="col-sm-6">
                        <select class="form-control" v-model="buildingDto.contributionId">
                            <option disabled value="">Select a value</option>
                            <option v-for="contribution in contributionList" :value="contribution.contributionId" :key="contribution.contributionId">
                                {{contribution.description}}
                            </option>
                        </select>
                    </div>
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'contributionId'" :hasAppend="false"></qaqcFormFieldSelect>
                </div>
                <div class="form-group">
                    <label class="col-md-2 control-label text-label">Identification</label>
                </div>
                <div class="form-group">
                    <div v-bind:class="{ 'has-error': errors.has('buildingForm.historicName') }">
                        <label class="col-md-2 col-md-offset-2 control-label text-label">Historic Name</label>
                        <div class="col-md-8">
                            <input type="text" class="form-control" v-model="buildingDto.historicName" name="historicName" v-validate="'required|max:255'">
                            <span v-show="errors.has('buildingForm.historicName')" class="has-error">{{ errors.first('buildingForm.historicName') }}</span>
                            <span style="font-size:11px; float:right;">{{ (buildingDto.historicName || '').length + '/255' }}</span>
                            <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'historicName'" :hasAppend="true"></qaqcFormFieldSelect>
                        </div>
                        
                    </div>
                </div>
                <div class="form-group">
                    <div v-bind:class="{ 'has-error': errors.has('buildingForm.otherCommonNames') }">
                        <label class="col-md-2 col-md-offset-2 control-label text-label">Other Common Names</label>
                        <div class="col-md-8">
                            <input type="text" class="form-control" v-model="buildingDto.otherCommonNames" name="otherCommonNames" v-validate="'max:255'">
                            <span v-show="errors.has('buildingForm.otherCommonNames')" class="has-error">{{ errors.first('buildingForm.otherCommonNames') }}</span>
                            <span style="font-size:11px; float:right;">{{ (buildingDto.otherCommonNames || '').length + '/255' }}</span>
                            <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'otherCommonNames'" :hasAppend="true"></qaqcFormFieldSelect>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-md-2 control-label text-label">Function and Setting</label>
                </div>
                <div class="form-group">
                    <label class="col-sm-2 col-sm-offset-2 control-label text-label">Current Function Type</label>
                    <div class="col-sm-8" >
                        <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'selectedCurrentFunction'" :hasAppend="true"></qaqcFormFieldSelect>
                        <div class="checkbox checkbox-inline" v-for="t in functionList" :key="t.buildingFunctionId">
                            <input type="checkbox" v-model="selectedCurrentFunction" :id="qaqcFieldId + 'currentFunction' + t.description" :value="t.buildingFunctionId" />
                            <label :for="qaqcFieldId + 'currentFunction' + t.description">{{ t.description}}</label>
                        </div>
                    </div>

                </div>
                <div  class="form-group">
                    <label class="col-sm-2 col-sm-offset-2 control-label text-label">Historic Function Type</label>
                    <div class="col-sm-8">
                        <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'selectedHistoricFunction'" :hasAppend="true"></qaqcFormFieldSelect>
                        <div class="checkbox checkbox-inline" v-for="t in functionList" :key="t.buildingFunctionId">
                            <input type="checkbox" v-model="selectedHistoricFunction" :id="qaqcFieldId + 'historicFunction' + t.description" :value="t.buildingFunctionId" />
                            <label :for="qaqcFieldId + 'historicFunction' + t.description">{{ t.description}}</label>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-sm-2 col-sm-offset-2 control-label text-label">Current Setting Type</label>
                    <div class="col-sm-8">
                        <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'selectedCurrentSetting'" :hasAppend="true"></qaqcFormFieldSelect>
                        <div v-for="t in settingList" class="checkbox checkbox-inline" :key="t.buildingSettingId">
                            <input type="checkbox" v-model="selectedCurrentSetting" :id="qaqcFieldId + 'currentSetting' + t.description" :value="t.buildingSettingId" />
                            <label :for="qaqcFieldId + 'currentSetting' + t.description">{{ t.description}}</label>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-sm-2 col-sm-offset-2 control-label text-label">Historic Setting Type</label>
                    <div class="col-sm-8">
                        <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'selectedHistoricSetting'" :hasAppend="true"></qaqcFormFieldSelect>
                        <div v-for="t in settingList" class="checkbox checkbox-inline" :key="t.buildingSettingId">
                            <input type="checkbox" v-model="selectedHistoricSetting" :id="qaqcFieldId + 'historicSetting' + t.description" :value="t.buildingSettingId" />
                            <label :for="qaqcFieldId + 'historicSetting' + t.description">{{ t.description}}</label>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-md-2 col-md-offset-2 control-label text-label">Setting Decription</label>
                    <div class="col-md-8">
                        <textarea class="form-control" v-model="buildingDto.settingDescription" />
                        <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'settingDescription'" :hasAppend="true"></qaqcFormFieldSelect>
                    </div>
                    
                </div>
                <div class="form-group">
                    <label class="col-md-2 control-label text-label">Classification and Description</label>
                </div>
                <div class="form-group">
                    <label class="col-md-2 control-label text-label">&nbsp;</label>
                    <div class="col-md-10">
                        <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'buildingStyleId'" :hasAppend="false"></qaqcFormFieldSelect>
                        <div class="form-group">
                            <div v-bind:class="{ 'has-error': errors.has('buildingForm.buildingStyleId') }">
                                <label class="col-md-1 control-label">Style</label>
                                <div class="col-md-2">
                                    <select class="form-control" v-model="buildingDto.buildingStyleId" name="buildingStyleId" v-validate="{ required: !buildingDto.isNonExtant }">
                                        <option disabled :value="null">Select a value</option>
                                        <option v-for="style in buildingStyleList" :value="style.buildingStyleId" :key="style.buildingStyleId">
                                            {{style.description}}
                                        </option>
                                    </select>
                                    <span v-show="errors.has('buildingForm.buildingStyleId')" class="has-error">{{ errors.first('buildingForm.buildingStyleId') }}</span>
                                </div>
                            </div>
                            <div v-bind:class="{ 'has-error': errors.has('buildingForm.buildingTypeId') }">
                                <label class="col-md-1 control-label">Type/Form</label>
                                <div  class="col-md-2">
                                    <select class="form-control" v-model="buildingDto.buildingTypeId" name="buildingTypeId" v-validate="{ required: !buildingDto.isNonExtant }">
                                        <option disabled :value="null">Select a value</option>
                                        <option v-for="buildingType in buildingTypeList" :value="buildingType.buildingTypeId" :key="buildingType.buildingTypeId" :disabled="buildingType.isHeader">
                                            {{buildingType.description}}
                                        </option>
                                    </select>
                                    <span v-show="errors.has('buildingForm.buildingTypeId')" class="has-error">{{ errors.first('buildingForm.buildingTypeId') }}</span>
                                </div>
                            </div>
                            <div v-bind:class="{ 'has-error': errors.has('buildingForm.storyId') }">
                                <label class="col-md-1 control-label">Stories</label>
                                <div  class="col-md-1">
                                    <select class="form-control" v-model="buildingDto.storyId" name="storyId" v-validate="{ required: !buildingDto.isNonExtant }">
                                        <option disabled :value="null">Select</option>
                                        <option v-for="story in storyList" :value="story.storyId" :key="story.storyId">
                                            {{story.description}}
                                        </option>
                                    </select>
                                    <span v-show="errors.has('buildingForm.storyId')" class="has-error">{{ errors.first('buildingForm.storyId') }}</span>
                                </div>
                            </div>
                            <div v-bind:class="{ 'has-error': errors.has('buildingForm.yesNoBasementId') }">
                                <label class="col-md-1 control-label">Basement</label>
                                <div  class="col-md-1">
                                    <select class="form-control" v-model="buildingDto.yesNoBasementId" name="yesNoBasementId" v-validate="{ required: !buildingDto.isNonExtant }">
                                        <option disabled :value="null">Select</option>
                                        <option v-for="yn in yesNoList" :value="yn.yesNoId" :key="yn.yesNoId">
                                            {{yn.description}}
                                        </option>
                                    </select>
                                    <span v-show="errors.has('buildingForm.yesNoBasementId')" class="has-error">{{ errors.first('buildingForm.yesNoBasementId') }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-group">
                        <div class="col-md-2">
                            <label>&nbsp;</label>
                        </div>
                        <div class="col-md-10">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th style="width:20%">Element</th>
                                    <th style="width:40%">Type</th>
                                    <th style="width:40%">Material</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="element in buildingDto.historicBuildingElementList" :key="element.buildingElementId">
                                    <td class="form-inline">
                                        <strong>{{element.description}}</strong>
                                        <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'historicBuildingElementList' + element.buildingElementId" :hasAppend="false"></qaqcFormFieldSelect>
                                    </td>
                                    <td v-bind:class="{ 'has-error': errors.has('buildingForm.buildingElementTypeId' + element.buildingElementId) }">
                                        <select class="form-control" v-model="element.buildingElementTypeId" :name="'buildingElementTypeId' + element.buildingElementId" v-validate="{ required: !buildingDto.isNonExtant }">
                                            <option disabled value=''>Select a value</option>
                                            <option v-for="elementType in elementTypeList.filter(x => {return x.buildingElementId === element.buildingElementId || !x.buildingElementId})"
                                                :value="elementType.elementTypeId" :key="elementType.elementTypeId">
                                                {{elementType.description}}
                                            </option>
                                        </select>
                                        <span v-show="errors.has('buildingForm.buildingElementTypeId' + element.buildingElementId)" class="has-error">Required</span>
                                    </td>
                                    <td v-bind:class="{ 'has-error': errors.has('buildingForm.buildingElementMaterialId' + element.buildingElementId) }">
                                        <select class="form-control" v-model="element.buildingElementMaterialId" :name="'buildingElementMaterialId' + element.buildingElementId" v-validate="{ required: !buildingDto.isNonExtant }">
                                            <option disabled value=''>Select a value</option>
                                            <option v-for="elementType in elementMaterialList.filter(x => {return x.buildingElementId === element.buildingElementId || !x.buildingElementId})"
                                                :value="elementType.elementMaterialId" :key="elementType.elementMaterialId">
                                                {{elementType.description}}
                                            </option>
                                        </select>
                                        <span v-show="errors.has('buildingForm.buildingElementMaterialId' + element.buildingElementId)" class="has-error">Required</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-md-1 col-md-offset-2 control-label text-label">Notable Features</label>
                    <div class="col-md-8">
                        <textarea type="text" class="form-control" v-model="buildingDto.notableFeatures" />
                    </div>
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'notableFeatures'" :hasAppend="true"></qaqcFormFieldSelect>
                </div>
                <div class="form-group">
                    <label class="col-md-1 col-md-offset-2 control-label text-label">Landscaping</label>
                    <div class="col-md-8">
                        <textarea type="text" class="form-control" v-model="buildingDto.landscaping" />
                    </div>
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'landscaping'" :hasAppend="true"></qaqcFormFieldSelect>
                </div>
                <div class="form-group">
                    <label class="col-md-1 col-md-offset-2 control-label text-label">Architectural Description</label>
                    <div class="col-md-8">
                        <textarea type="text" class="form-control" v-model="buildingDto.architecturalDescription" />
                    </div>
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'architecturalDescription'" :hasAppend="true"></qaqcFormFieldSelect>
                </div>
                <div class="form-group">
                    <div v-bind:class="{ 'has-error': errors.has('buildingForm.buildingIntegrityId') }">
                        <label class="col-md-1 col-md-offset-2 control-label text-label">Integrity</label>
                        <div class="col-md-4 form-inline">
                            <select class="form-control" v-model="buildingDto.buildingIntegrityId" name="buildingIntegrityId" v-validate="{ required: !buildingDto.isNonExtant }">
                                <option disabled :value="null">Select a value</option>
                                <option v-for="integrity in buildingIntegrityList" :value="integrity.buildingIntegrityId" :key="integrity.buildingIntegrityId">
                                    {{integrity.description}}
                                </option>
                            </select>
                            <span v-show="errors.has('buildingForm.buildingIntegrityId')" class="has-error">{{ errors.first('buildingForm.buildingIntegrityId') }}</span>
                            <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'buildingIntegrityId'" :hasAppend="false"></qaqcFormFieldSelect>
                        </div>
                    </div>
                    <div v-bind:class="{ 'has-error': errors.has('buildingForm.buildingConditionId') }">
                        <label class="col-md-1 control-label text-label">Condition</label>
                        <div class="col-md-4 form-inline">
                            <select class="form-control" v-model="buildingDto.buildingConditionId" name="buildingConditionId" v-validate="{ required: !buildingDto.isNonExtant }">
                                <option disabled :value="null">Select a value</option>
                                <option v-for="condition in buildingConditionList" :value="condition.buildingConditionId" :key="condition.buildingConditionId">
                                    {{condition.description}}
                                </option>
                            </select>
                            <span v-show="errors.has('buildingForm.buildingConditionId')" class="has-error">{{ errors.first('buildingForm.buildingConditionId') }}</span>
                            <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'buildingConditionId'" :hasAppend="false"></qaqcFormFieldSelect>
                        </div>
                    </div>
                </div>
                <div class="form-group" v-bind:class="{ 'has-error': errors.has('buildingForm.comment') }">
                    <label class="col-md-1 col-md-offset-2 control-label text-label">Comments</label>
                    <div class="col-md-8">
                        <textarea type="text" class="form-control" v-model="buildingDto.comment" name="comment" v-validate="{ required: !buildingDto.isNonExtant }" />
                        <span v-show="errors.has('buildingForm.comment')" class="has-error">{{ errors.first('buildingForm.comment') }}</span>
                    </div>
                    
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'comment'" :hasAppend="false"></qaqcFormFieldSelect>
                </div>
                <div class="form-group">
                    <label class="col-md-2 control-label">Construction and Alteration</label>
                </div>
                <div class="form-group">
                    <div class="col-md-10 col-md-offset-2">
                        <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'historicBuildingConstructionDateList'" :hasAppend="true"></qaqcFormFieldSelect>
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>Type</th>
                                    <th>Date</th>
                                    <th>Estimated</th>
                                    <th>Comment</th>
                                    <th>Source</th>
                                    <th>Remove</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(date, index) in constructionDates" :key="index">
                                    <td>{{date.constructionDateTypeDescription}}</td>
                                    <td>{{date.date}}</td>
                                    <td>{{date.isEstimate ? 'Yes' : 'No'}}</td>
                                    <td>{{date.comment}}</td>
                                    <td>{{date.source}}</td>
                                    <td><a class="fa fa-ban" style="font-size: 18px;" v-on:click="removeConstructionDate(index)"></a></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div  v-if="!formDisabled" class="form-group">
                    <div class="col-md-1 col-md-offset-10">
                        <button class="form-contol btn" v-on:click="$refs['constructionDateModal'].open()">Add Construction Dates</button>
                    </div>
                </div>
                <div class="form-group">
                    <label class="col-md-1 col-md-offset-2 control-label text-label">Architect(s) / Builder(s)</label>
                    <div class="col-md-8">
                        <textarea type="text" class="form-control" v-model="buildingDto.architect" rows="1" />
                    </div>
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'architect'" :hasAppend="true"></qaqcFormFieldSelect>
                </div>
                <div class="form-group">
                    <label class="col-md-1 col-md-offset-2 control-label text-label">Historic Function(s)</label>
                    <div class="col-md-8">
                        <textarea type="text" class="form-control" v-model="buildingDto.historicFunction" rows="1" />
                    </div>
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'historicFunction'" :hasAppend="true"></qaqcFormFieldSelect>
                </div>
                <div class="form-group">
                    <label class="col-md-1 col-md-offset-2 control-label text-label">Alterations</label>
                    <div class="col-md-8">
                        <textarea type="text" class="form-control" v-model="buildingDto.alteration" rows="1" />
                    </div>
                    <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'alteration'" :hasAppend="true"></qaqcFormFieldSelect>
                </div>
                <div v-if="!qaqcEnabled" class="form-group">
                    <label class="col-md-2 control-label text-label">File Attachments</label>
                    <div class="col-md-10">
                        <table class="table">
                            <thead>
                                <tr>
                                    <th>Download</th>
                                    <th>File Name</th>
                                    <th>Comment</th>
                                    <th>Uploaded By</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="mediaItem in mediaList" :key="mediaItem.mediaId">
                                    <td>
                                        <div style="text-align: center;">
                                            <a class="fa fa-cloud-download" style="font-size: 18px;" target="_blank" v-on:click="mediaDownloadRow(mediaItem.mediaId, mediaItem.mediaTypeId, mediaItem.mediaSubtypeId, mediaItem.parentId, mediaItem.filename)"></a>
                                        </div>
                                    </td>
                                    <td>{{mediaItem.filename}}</td>
                                    <td>{{mediaItem.comment}}</td>
                                    <td>{{mediaItem.createdBy}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div  v-if="!(formDisabled || qaqcEnabled)" class="form-group">
                    <div class="col-md-3 col-md-offset-2">
                        <input name="newFile" ref="newFile" class="form-control" type="file">
                    </div>
                    <label class="col-md-1 control-label text-label">Comment</label>
                    <div class="col-md-4">
                        <input type="text" class="form-control" v-model="imageComment">
                    </div>
                    <button class="btn btn-primary col-md-1"  v-on:click="addBuildingFile">Add</button>
                </div>
                <div class="form-group" style="margin-top: 10px;">
                    <label class="col-md-2 control-label text-label"></label>
                    <div class="col-md-10">
                        <qaqcFormFieldSelect v-if="qaqcEnabled" :fieldData="qaqcSelection" :fieldName="'isNonExtant'" :hasAppend="false"></qaqcFormFieldSelect>
                        <input style="width: 20px; height: 20px;" type="checkbox" v-model="buildingDto.isNonExtant" :id="qaqcFieldId + 'hbfIsNonExtant'" />
                        <label class="control-label text-label" style="font-size: 12px;" :for="qaqcFieldId + 'hbfIsNonExtant'">Non-Extant</label>
                    </div>
                </div>
            </form>
        </fieldset>
        <form class="form form-horizontal" v-on:submit.prevent>
            <div class="form-group">
                <hr>
                <div class="row" style='margin-left:10px'>
                    <div class="col-xs-4 text-center">
                        <button class="btn btn-primary" style="margin-left:10px" v-on:click="previousHistoricBuilding" :disabled="currentAttachmentNumber === 1">Previous</button>
                    </div>
                    <div v-if="!(formDisabled)" class="col-xs-4 text-center">
                        <button class="btn btn-primary" v-on:click="qaqcEnabled ? completeSection('historicBuilding') : saveHistoricBuilding()">Save</button>
                    </div>
                    <div class="col-xs-4 text-center">
                        <button class="btn btn-primary" v-on:click="nextHistoricBuilding" :disabled="dtoIsNew || currentAttachmentNumber >= attachmentCount">Next</button>
                    </div>
                </div>
                <qaqcFormFieldFooter v-if="qaqcEnabled" :qaqcProgressDto="qaqcProgressDto" :qaqcSelection="qaqcSelection" :sectionName="'historicBuilding'" :completeSection="completeSection"></qaqcFormFieldFooter>
            </div>
        </form>
        <modal ref="constructionDateModal">
            <div slot="header">
                <h3 class="pull-left">Construction Dates</h3>
                <button class="btn pull-right" v-on:click="$refs['constructionDateModal'].close()">X</button>
            </div>
            <div slot="body">
                <form v-on:submit.prevent data-vv-scope="constructionForm">
                    <div class="form form-horizontal">
                        <div class="form-group" v-bind:class="{ 'has-error': errors.has('constructionForm.constructionDateTypeId') }">
                            <label class="col-md-4 control-label">Date type</label>
                            <div class="col-md-8">
                                <select class="form-control" v-model="constructionDateDto.constructionDateTypeId" name="constructionDateTypeId" v-validate="{ required: !buildingDto.isNonExtant, max: 255 }">
                                    <option disabled value="">Select a value</option>
                                    <option  v-for="dateType in constructionDateTypes" :value="dateType.constructionDateTypeId" :key="dateType.constructionDateTypeId">
                                        {{dateType.description}}
                                    </option>
                                </select>
                                <span v-show="errors.has('constructionForm.constructionDateTypeId')" class="has-error">Required</span>
                            </div>
                        </div>
                        <div class="form-group" v-bind:class="{ 'has-error': errors.has('constructionForm.date') }">
                            <label class="col-md-4 control-label">Date</label>
                            <div class="col-md-8">
                                <input type="text" class="form-control" v-model="constructionDateDto.date" name="date" v-validate="{ required: !buildingDto.isNonExtant }">
                                <span v-show="errors.has('constructionForm.date')" class="has-error">Required</span>
                            </div>
                        </div>
                        <div class="form-group">
                            <label class="col-md-4 control-label">Estimated</label>
                            <div class=" col-md-2">
                                <div class="checkbox checkbox-inline" style="padding-top:0px">
                                    <input :id="qaqcFieldId + 'estimateCB'" type="checkbox" v-model="constructionDateDto.isEstimate" />
                                    <label :for="qaqcFieldId + 'estimateCB'">&nbsp;</label>
                                </div>
                            </div>
                        </div>
                        <div class="form-group" v-bind:class="{ 'has-error': errors.has('constructionForm.comment') }">
                            <label class="col-md-4 control-label">Comment</label>
                            <div class="col-md-8">
                                <input type="text" class="form-control" v-model="constructionDateDto.comment" name="comment" v-validate="{ required: !buildingDto.isNonExtant, max: 255 }">
                                <span v-show="errors.has('constructionForm.comment')" class="has-error">{{ errors.first('constructionForm.comment') }}</span>
                                <span style="font-size:11px; float:right;">{{ (constructionDateDto.comment || '').length + '/255' }}</span>
                            </div>
                        </div>
                        <div class="form-group" v-bind:class="{ 'has-error': errors.has('constructionForm.source') }">
                            <label class="col-md-4 control-label">Source</label>
                            <div class="col-md-8">
                                <input type="text" class="form-control" v-model="constructionDateDto.source" name="source" v-validate="{ required: !buildingDto.isNonExtant, max: 255 }">
                                <span v-show="errors.has('constructionForm.source')" class="has-error">{{ errors.first('constructionForm.source') }}</span>
                                <span style="font-size:11px; float:right;">{{ (constructionDateDto.source || '').length + '/255' }}</span>
                            </div>
                        </div>
                    </div>
                </form>   
            </div>
            <div slot="footer">
                <button name="buttonDone" class="btn btn-primary col-md-3" v-on:click="constructionDatesDone()">Done</button>
                <button name="buttonMore" class="btn btn-primary col-md-3 pull-right" v-on:click="constructionDatesMore()">More</button>
            </div>
        </modal>
    </div>
</template>

<script>
import loggingService from '../../services/util/loggingService'
import historicBuildingService from '../../services/siteForm/historicBuildingService'
import mediaService from '../../services/mediaService'
import modal from '../Modal.vue'
import qaqcService from '@/services/qaqcService'
import qaqcFormFieldSelect from '@/components/SiteForm/QaqcFormFieldSelect.vue'
import qaqcFormFieldFooter from '@/components/SiteForm/QaqcFormFieldFooter.vue'
import loader from '@/components/Loader.vue'

export default {
    name: 'historicBuildingForm',
    components: {
        modal,
        qaqcFormFieldSelect,
        qaqcFormFieldFooter,
        loader
    },
    data: function () {
        return {
            isDebug: false,
            isLoading: false,
            buildingDto: {},
            constructionDateDto: {},
            selectedHistoricFunction: [],
            selectedCurrentFunction: [],
            selectedHistoricSetting: [],
            selectedCurrentSetting: [],
            functionList: [],
            settingList: [],
            elementList: [],
            elementTypeList: [],
            elementMaterialList: [],
            buildingStyleList: [],
            buildingTypeList: [],
            buildingIntegrityList: [],
            buildingConditionList: [],
            storyList: [],
            constructionDates: [],
            constructionDateTypes: [],
            yesNoList: [],
            mediaList: [],
            currentAttachmentNumber: 1,
            existingAttachments: 0,
            imageComment: '',
            productionAttachmentList: [],
            contributionList: [
                {contributionId: 1, description: 'Contributes'},
                {contributionId: 2, description: 'Does not contribue'},
                {contributionId: 3, description: 'Unevaluated'}
            ]
            //buildingAttachmentList: []
        }
    },
    props: {
        attachmentCount: {},
        formDisabled: { default: false },
        qaqcEnabled: { default: false },
        productionCrrId: { default: null },
        qaqcProgressDto: { default: () => {} },
        saveQaqcProgress: { default: null },
        crrId: { default: null },
        isSegment: { default: false },
        //segmentList: { default: null },
        projectId: { default: null }
    },
    computed: {
        qaqcSelection: function () {
            if (this.qaqcProgressDto && this.qaqcProgressDto.qaqcSelections) {
                // // if there's no historicBuilding or historicBuildingSelection qa/qc objects, create new instance
                // if (!this.qaqcProgressDto.qaqcSelections.historicBuilding || this.qaqcProgressDto.qaqcSelections.historicBuilding.length === 0) {
                //     this.qaqcProgressDto.qaqcSelections.historicBuilding = []
                //     for (var i = 0; i < this.attachmentCount; i++) {
                //         this.qaqcProgressDto.qaqcSelections.historicBuilding.push(qaqcService.historicBuildingSelection())
                //     }
                // }

                // more selections than counts, remove extras
                if (this.qaqcProgressDto.qaqcSelections.historicBuilding.length > this.attachmentCount) {
                    let difference = this.qaqcProgressDto.qaqcSelections.historicBuilding.length - this.attachmentCount
                    for (let i = 0; i < difference; i++) {
                        this.qaqcProgressDto.qaqcSelections.historicBuilding.pop()
                    }
                }
                // more counts than selections, add more
                if (this.qaqcProgressDto.qaqcSelections.historicBuilding.length < this.attachmentCount) {
                    let difference = this.attachmentCount - this.qaqcProgressDto.qaqcSelections.historicBuilding.length
                    for (let i = 0; i < difference; i++) {
                        this.qaqcProgressDto.qaqcSelections.historicBuilding.push(qaqcService.historicBuildingSelection())
                    }
                }
                // return the current attachment number's selection in the historicBuilding array
                var selection = this.qaqcProgressDto.qaqcSelections.historicBuilding[this.currentAttachmentNumber - 1] || qaqcService.historicBuildingSelection()
                if (!selection.isNonExtant) selection.isNonExtant = 0
                return selection
            } else {
                return {}
            }
        },
        qaqcFieldId: function () {
            return this.qaqcEnabled ? 'qaqc' : ''
        },
        dtoIsNew: function () {
            return !this.buildingDto.historicBuildingFormId || this.buildingDto.historicBuildingFormId === 0
        }
        // selectableSegmentList: function () {
        //     if (this.segmentList) {
        //         return this.segmentList.filter(x => {
        //             return (!this.buildingAttachmentList.some(dto => { return dto.memberCulturalResourceId === x.culturalResourceId }) || x.culturalResourceId === this.buildingDto.memberCulturalResourceId)
        //         })
        //     } else {
        //         return []
        //     }
        // }
    },
    watch: {
        crrId: function (val) {
            this.log('crrId is changed: ' + val)
            this.loadLookups().then(result => {
                this.loadData().then(result => {
                    this.isLoading = false
                })
            })
        },
        productionCrrId: function (val) {
            this.log('productionCrrId is changed: ' + val)
            this.loadProductionAttachments()
        }
        // segmentList: function (val) {
        //     this.log('segmentList is changed: ' + val)
        //     this.loadLookups().then(result => {
        //         this.loadData().then(result => {
        //             this.isLoading = false
        //         })
        //     })
        // }
    },
    mounted () {
        this.isLoading = true
        if (this.crrId /* && this.segmentList */) {
            this.loadLookups().then(result => {
                this.loadData().then(result => {
                    if (this.productionCrrId) {
                        this.loadProductionAttachments()
                    }
                    this.isLoading = false
                })
            })
        }
    },
    methods: {
        log (message) {
            loggingService.log(this.isDebug, 'Historic Artifact Form', message)
        },
        loadData () {
            var crrId = this.crrId
            return historicBuildingService.search(this.$http, {culturalResourceRecordingId: crrId}).then(result => {
                if (result.data.length > 0) {
                    this.existingAttachments = result.data.length
                    //this.buildingAttachmentList = result.data
                    // reset selected lists
                    this.selectedHistoricFunction = []
                    this.selectedCurrentFunction = []
                    this.selectedHistoricSetting = []
                    this.selectedCurrentSetting = []
                    this.constructionDates = []

                    //find the current attachment, create new if cannot find
                    this.buildingDto = result.data.find(x => x.attachmentNumber === this.currentAttachmentNumber)
                    if (!this.buildingDto) {
                        this.log('Creating new attachments')
                        this.createBuildingDto()
                    } else {
                        //set formId to qaqcSelection
                        if (this.qaqcEnabled) {
                            this.qaqcSelection.currentFormId = this.buildingDto.historicBuildingFormId
                        }
                        // this.currentAttachmentNumber++
                        this.buildingDto = result.data.find(x => x.attachmentNumber === this.currentAttachmentNumber)
                        this.log('Current Attachment: ' + this.buildingDto.historicBuildingFormId)
                        this.buildingDto.historicBuildingFunctionList.forEach(x => {
                            if (x.isHistoric) {
                                this.selectedHistoricFunction.push(x.buildingFunctionId)
                            } else {
                                this.selectedCurrentFunction.push(x.buildingFunctionId)
                            }
                        })
                        this.buildingDto.historicBuildingSettingList.forEach(x => {
                            if (x.isHistoric) {
                                this.selectedHistoricSetting.push(x.buildingSettingId)
                            } else {
                                this.selectedCurrentSetting.push(x.buildingSettingId)
                            }
                        })
                        this.buildingDto.historicBuildingElementList.forEach(x => {
                            x.description = this.elementList.find(y => { return x.buildingElementId === y.buildingElementId }).description
                        })
                        //add unsaved building elements
                        this.elementList.forEach(ele => {
                            if (!this.buildingDto.historicBuildingElementList.some(x => x.buildingElementId === ele.buildingElementId)) {
                                this.buildingDto.historicBuildingElementList.push(
                                    {
                                        buildingElementId: ele.buildingElementId,
                                        description: ele.description,
                                        buildingElementTypeId: '',
                                        buildingElementMaterialId: ''
                                    })
                            }
                        })

                        // set the constructionDates list
                        this.constructionDates = this.buildingDto.historicBuildingConstructionDateList
                        // set the constructionDateTypeDescriptions
                        this.constructionDates.forEach(date => {
                            var val = this.constructionDateTypes.find(x => {
                                return x.constructionDateTypeId === date.constructionDateTypeId
                            })
                            date.constructionDateTypeDescription = val ? val.description : ''
                        })

                        mediaService.list(this.$http, mediaService.mediaType.CulturalResourceImages, mediaService.mediaSubtype.BuildingImage, this.buildingDto.historicBuildingFormId).then(result => {
                            this.log(`found ${result.data.length} media items`)
                            this.mediaList = result.data
                            return result
                        })
                    }
                } else {
                    this.createBuildingDto()
                }
            })
        },
        createBuildingDto () {
            this.buildingDto = {
                culturalResourceRecordingId: this.crrId,
                buildingStyleId: null,
                buildingTypeId: null,
                storyId: null,
                yesNoBasementId: null,
                buildingIntegrityId: null,
                buildingConditionId: null,
                attachmentNumber: this.currentAttachmentNumber
            }
            this.buildingDto.historicBuildingElementList = this.elementList.map(element => {
                return {
                    buildingElementId: element.buildingElementId,
                    description: element.description,
                    buildingElementTypeId: '',
                    buildingElementMaterialId: ''
                }
            })
            /* This isn't needed, I don't think
            this.selectedCurrentFunction = []
            this.selectedHistoricFunction = []
            this.selectedCurrentSetting = []
            this.selectedHistoricSetting = []
            this.constructionDates = []
            this.mediaList = []*/
        },
        loadLookups () {
            this.functionList = historicBuildingService.getBuildingFunctionList()
            this.settingList = historicBuildingService.getBuildingSettingList()
            this.buildingStyleList = historicBuildingService.getBuildingStyleList()
            var rawTypeList = historicBuildingService.getBuildingTypeList()
            historicBuildingService.getBuildingTypeCategory().forEach(category => {
                this.buildingTypeList.push({ isHeader: 1, description: category.description.toUpperCase() })
                var subset = rawTypeList.filter(t => { return t.buildingCategoryId === category.buildingCategoryId })
                this.buildingTypeList = this.buildingTypeList.concat(subset)
            })
            this.storyList = historicBuildingService.getStoryList()
            this.yesNoList = [
                {yesNoId: 1, description: 'Yes'},
                {yesNoId: 2, description: 'No'},
                {yesNoId: 3, description: 'Unknown'}
            ]
            this.elementList = historicBuildingService.getElementList()
            this.elementTypeList = historicBuildingService.getElementTypeList()
            this.elementMaterialList = historicBuildingService.getElementMaterialList()
            this.buildingIntegrityList = historicBuildingService.getBuildingIntegrityList()
            this.buildingConditionList = historicBuildingService.getBuildingConditionList()
            this.constructionDateTypes = historicBuildingService.getConstructionDateTypes()
            return Promise.resolve(1)
        },
        constructionDatesDone () {
            this.$validator.validateAll('constructionForm').then(result => {
                if (result) {
                    var val = this.constructionDateTypes.find(x => {
                        return x.constructionDateTypeId === this.constructionDateDto.constructionDateTypeId
                    })
                    this.constructionDateDto.constructionDateTypeDescription = val.description
                    this.constructionDates.push(this.constructionDateDto)
                    this.constructionDateDto = {}
                    this.$refs.constructionDateModal.close()
                }
            })
        },
        constructionDatesMore () {
            this.$validator.validateAll('constructionForm').then(result => {
                if (result) {
                    var val = this.constructionDateTypes.find(x => {
                        return x.constructionDateTypeId === this.constructionDateDto.constructionDateTypeId
                    })
                    this.constructionDateDto.constructionDateTypeDescription = val.description
                    this.constructionDates.push(this.constructionDateDto)
                    this.constructionDateDto = {}
                }
            })
        },
        addBuildingFile () {
            this.log('Number of files:' + this.$refs['newFile'].files.length + ', Name: ' + this.$refs['newFile'].files[0].name)
            this.mediaList.push({file: this.$refs['newFile'].files[0], comment: this.imageComment})
            this.$refs['newFile'].value = ''
            this.imageComment = ''
        },
        saveHistoricBuilding () {
            this.isLoading = true
            return new Promise((resolve) => {
                this.$validator.validateAll('buildingForm').then(valResult => {
                    if (valResult) {
                        this.buildingDto.historicBuildingFunctionList = []
                        this.buildingDto.historicBuildingSettingList = []
                        this.selectedHistoricFunction.forEach(x => {
                            this.buildingDto.historicBuildingFunctionList.push({
                                isHistoric: true,
                                isCurrent: false,
                                buildingFunctionId: parseInt(x),
                                buildingFuncitonDetailId: 0
                            })
                        })
                        this.selectedCurrentFunction.forEach(x => {
                            this.buildingDto.historicBuildingFunctionList.push({
                                isHistoric: false,
                                isCurrent: true,
                                buildingFunctionId: parseInt(x),
                                buildingFuncitonDetailId: 0
                            })
                        })
                        this.selectedHistoricSetting.forEach(x => {
                            this.buildingDto.historicBuildingSettingList.push({
                                isHistoric: true,
                                isCurrent: false,
                                buildingSettingId: parseInt(x),
                                historicBuildingSettingId: 0,
                                historicBuildingFormId: 0
                            })
                        })
                        this.selectedCurrentSetting.forEach(x => {
                            this.buildingDto.historicBuildingSettingList.push({
                                isHistoric: false,
                                isCurrent: true,
                                buildingSettingId: parseInt(x),
                                historicBuildingSettingId: 0,
                                historicBuildingFormId: 0
                            })
                        })
                        // prep building element list
                        this.buildingDto.historicBuildingElementList = this.buildingDto.historicBuildingElementList.filter(x => Number(x.buildingElementTypeId) !== 0 && Number(x.buildingElementMaterialId) !== 0)
                        // prep the construction date list
                        this.buildingDto.historicBuildingConstructionDateList = []
                        this.constructionDates.forEach(date => {
                            this.buildingDto.historicBuildingConstructionDateList.push(date)
                        })
                        this.log(`building type: ${this.buildingDto.buildingTypeId}, building style: ${this.buildingDto.buildingStyleId}`)
                        historicBuildingService.put(this.$http, this.buildingDto).then(result => {
                            this.buildingDto.historicBuildingFormId = result.data.objectList[0].historicBuildingFormId
                            var panelId = result.data.objectList[0].historicBuildingFormId
                            var handle = this
                            var promises = []
                            this.mediaList.forEach(attachment => {
                                if (attachment.file) {
                                    var newPromise = mediaService.putFile(
                                        handle.$http,
                                        mediaService.mediaType.CulturalResourceImages,
                                        mediaService.mediaSubtype.BuildingImage,
                                        panelId,
                                        attachment.file,
                                        attachment.comment)
                                    promises.push(newPromise)
                                }
                            })
                            //Run through each save
                            Promise.all(promises).then(fileUploadResults => {
                                this.log('done saving form')
                                this.loadData()
                                this.isLoading = false
                                resolve(result)
                            })
                        })
                    } else {
                        this.log('save builing form - invalid form')
                        this.isLoading = false
                        resolve(1)
                    }
                })
            })
        },
        previousHistoricBuilding () {
            --this.currentAttachmentNumber
            this.loadData().then(x => {
                this.errors.clear('buildingForm')
            })
        },
        nextHistoricBuilding () {
            ++this.currentAttachmentNumber
            this.loadData().then(x => {
                this.errors.clear('buildingForm')
            })
        },
        mediaDownloadRow (mediaId, mediaTypeId, mediaSubtypeId, parentId, filename) {
            this.log(`mediaDownloadRow - mediaId: ${mediaId} , mediaTypeId: ${mediaTypeId}, parentId: ${parentId}`)
            mediaService.get(this.$http, mediaId, mediaTypeId, mediaSubtypeId, parentId).then(function (response) {
                mediaService.saveFileToDownload(response, filename)
            })
        },
        removeConstructionDate (index) {
            this.constructionDates.splice(index, 1)
        },
        checkSelectionComplete (selection) {
            for (let key in selection) {
                if (String(key) === 'attachmentSelection' && selection[key] === -1) return false
                if (this.isSegment && (String(key) !== 'attachmentSelection' && selection[key] === 0)) return false
                if (!this.isSegment && (String(key) !== 'attachmentSelection' && String(key) !== 'contributionId') && selection[key] === 0) {
                    return false
                }
            }
            return true
        },
        completeSection (sectionName) {
            // set the consolidated selection fields
            this.qaqcSelection.buildingTypeId = this.qaqcSelection.buildingStyleId
            this.qaqcSelection.storyId = this.qaqcSelection.buildingStyleId
            this.qaqcSelection.yesNoBasementId = this.qaqcSelection.buildingStyleId

            //save the current historicBuildingFormId to selection
            this.saveHistoricBuilding().then(response => {
                if (!this.buildingDto.historicBuildingFormId) {
                    alert('Building Form has not been saved. Cannot complete section.')
                    return
                }
                this.qaqcSelection.currentFormId = this.buildingDto.historicBuildingFormId

                //check if all selections have been made
                if (this.qaqcSelection.attachmentSelection === -1) {
                    alert('Please complete Attachment Selection')
                    return
                }
                if (!this.checkSelectionComplete(this.qaqcSelection)) {
                    alert('Please complete all QA/QC selections in this section.')
                    return
                }

                var sectionComplete = true
                //check if the other historicBuilding selections have been complete
                this.qaqcProgressDto.qaqcSelections.historicBuilding.forEach(selection => {
                    if (!this.checkSelectionComplete(selection)) { sectionComplete = false }
                })
                this.saveQaqcProgress(sectionName, sectionComplete)
            })
        },
        loadProductionAttachments () {
            this.productionAttachmentList = []
            return historicBuildingService.search(this.$http, {culturalResourceRecordingId: this.productionCrrId}).then(result => {
                result.data.forEach(attachment => {
                    this.productionAttachmentList.push(attachment)
                })
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// HistoricBuildingForm.vue?270d111c